export const indianStates = [
    "Out Of State",
    "Gujarat",
    "SEZ"
]